import _ from 'lodash'
import config from 'scoreboard/components/config'
import momentHelper from 'scoreboard/components/moment-helper'
import unwrapModel from 'scoreboard/components/unwrap-model'

/**
 * Returns the moment.js time format to use for a given time or date/time field
 *
 * @param {DatasetField|Object} field
 */
function datasetFieldTimeFormat (field) {
	field = unwrapModel(field)
	const timeDisplayType = _.get(field, 'timeDisplayType', config.defaultTimeDisplayType)
	return momentHelper.getTimeFormat(timeDisplayType)
}

export default datasetFieldTimeFormat

datasetFieldTimeFormat.__filename__ = 'datasets/dataset-field-time-format.js'
